import { useContext } from "react";
import { IUseLanguageContext } from "@helper/react-context/context-hooks/use-language-context";
import { Context } from "@helper/react-context/context-provider";

// Hook for easier use of the specific context without the need to call useContext() and import the global Context itself.
const useLanguage = (): IUseLanguageContext => useContext(Context).language;

export default useLanguage;
